// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__HP21J","links":"Partners_links__SUTBe"};